// eslint-disable-next-line no-process-env
const version = process.env.VERSION;

module.exports = {
  version,
  api: {
    url: `/api/${version}`,
    endpoints: {
      customerAccounts: {
        list: {
          path: 'customer-accounts/list/:page',
          query: {
            count: 20,
            search: null,
          },
        },
        extract: 'customer-accounts/:accountId/extract',
        byId: 'customer-accounts/:accountId',
        update: 'customer-accounts/:accountId/update',
        new: 'customer-accounts/new',
        activities: 'activities/:accountId/:page',
      },
      productFeeds: {
        settings: 'product-feeds/settings/:accountId',
        products: {
          list: {
            path: 'product-feeds/products/:accountId/list/:page',
            query: {
              count: 20,
              search: null,
            },
          },
          extract: 'product-feeds/products/:accountId/:productId/extract',
          settings: 'product-feeds/products/:accountId/:productId/settings',
          categories: 'product-feeds/products/:accountId/:productId/categories',
          ids: 'product-feeds/products/:accountId/:productId/ids',
          extras: 'product-feeds/products/:accountId/:productId/extras',
          syndication: 'product-feeds/products/:accountId/:productId/syndication',
        },
        jobs: {
          variants: 'product-feeds/jobs/:accountId/variants',
          new: 'product-feeds/jobs/:accountId/new',
          update: 'product-feeds/jobs/:accountId/:jobId/update',
          list: {
            path: 'product-feeds/jobs/:accountId/list/:page',
            query: {
              count: 20,
            },
          },
          byId: 'product-feeds/jobs/:accountId/:jobId',
          log: 'product-feeds/jobs/:accountId/:jobId/log',
          entries: 'product-feeds/jobs/:accountId/:jobId/:fromEntry',
          failed: 'product-feeds/jobs/failed',
          cancel: 'product-feeds/jobs/:accountId/:jobId',
        },
      },
    },
  },
};
